import { useEffect, useMemo, useState } from "react";
import { LottieSvg } from "lottie-react";
import { cn } from "@/lib/utils";

/**
 * Brand Lottie (stordinnkvartering.no): modulane byggjer seg opp. Teikna for kvit flate: topp = navy, venstre = blå,
 * høgre = svart. På navy-flater (login, presentasjons-intro) løftar vi toppflatene til papirkvitt og djupnar høgresidene
 * så modulane les som 3D. Delt mellom LoginPage og presentasjonen.
 */
const RECOLOR = [
  [[0.122, 0.141, 0.275], [0.94, 0.95, 0.98]],
  [[0, 0, 0], [0.055, 0.07, 0.16]],
];
const near = (a, b) => a.length >= 3 && Math.abs(a[0] - b[0]) < 0.02 && Math.abs(a[1] - b[1]) < 0.02 && Math.abs(a[2] - b[2]) < 0.02;
const recolor = (node) => {
  if (Array.isArray(node)) return node.map(recolor);
  if (node && typeof node === "object") {
    const out = {};
    for (const [k, v] of Object.entries(node)) out[k] = recolor(v);
    if (out.ty === "fl" && out.c && Array.isArray(out.c.k) && typeof out.c.k[0] === "number") {
      const hit = RECOLOR.find(([from]) => near(out.c.k, from));
      if (hit) out.c = { ...out.c, k: [...hit[1], out.c.k[3] ?? 1] };
    }
    return out;
  }
  return node;
};

/** Hentar Lottie-fila éin gong; `onNavy` = fargar om for mørk flate. */
export const useBrandAnimation = ({ onNavy = true } = {}) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    fetch("/brand/stord-modules.json").then((r) => (r.ok ? r.json() : null)).then((j) => { if (alive && j) setData(onNavy ? recolor(j) : j); }).catch(() => {});
    return () => { alive = false; };
  }, [onNavy]);
  return data;
};

export const ModulesAnimation = ({ data, className, loop = true, testId = "login-brand-animation" }) => {
  const reduce = useMemo(() => typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches, []);
  if (!data) return <div className={cn("aspect-[16/9]", className)} aria-hidden />;
  return (
    <LottieSvg src={data} loop={loop && !reduce} autoplay={!reduce} rendererSettings={{ preserveAspectRatio: "xMidYMid meet", progressiveLoad: true }}
      className={cn("aspect-[16/9]", className)} aria-label="Modulbygg som bygges opp" role="img" data-testid={testId} />
  );
};
